import { render } from "./Dashboard.vue?vue&type=template&id=00641c26&scoped=true&lang=pug"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=00641c26&lang=scss&scoped=true"
import "./Dashboard.vue?vue&type=style&index=1&id=00641c26&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00641c26"]])

export default __exports__